var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProperty = function SvgProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".property_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15.5H3.5a.5.5 0 0 0-.4.2l-2.25 3a.5.5 0 0 0 .4.8H7a.5.5 0 0 0 .4-.2ZM13.25 19.5l-3-4",
    className: "property_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 19.5V23a.5.5 0 0 0 .5.5h6.5v-5.333M8.25 23.5h3.5a.5.5 0 0 0 .5-.5v-4.833M23.25 5.5 19.4.688A.5.5 0 0 0 19.01.5h-8.52a.5.5 0 0 0-.39.188l-3.2 4a.5.5 0 0 0 .39.812h7.72a.5.5 0 0 0 .39-.188l3.809-4.77M10.25 21.5v2",
    className: "property_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 20.5h5.5a.5.5 0 0 0 .5-.5V4.25M14.753 20.5h1.497V4.25M7.25 5.5v8M18.25 6.5v1M20.25 6.5v1M18.25 10.5v1M20.25 10.5v1M18.25 14.5v1M20.25 14.5v1",
    className: "property_svg__a"
  })));
};
export default SvgProperty;